import { Component, OnInit } from '@angular/core';
import { LoanappService } from 'app/services/loanapp.service';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-agreement',
  templateUrl: './agreement.component.html',
  styleUrls: ['./agreement.component.css'],
})
export class AgreementComponent implements OnInit {
  accepted: Boolean = false;
  btnClicked: Boolean = false;
  appId = String;
  appIdFound: Boolean = false;
  otpVerified: Boolean = false;
  otpSent: Boolean = false;
  phoneNo: String = '';
  signInClicked: Boolean = false;
  otp: String;
  errMsg: string = 'Please wait..';
  appDetails: any;
  dApp: any;
  btnShow: Boolean = true;

  constructor(
    private lapp: LoanappService,
    private activatedRoute: ActivatedRoute,
    private toastr: ToastrService
  ) {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.appId = params['appId'];
      if (this.appId) {
        this.appIdFound = true;
        this.sendOtpForVerification(this.appId);
      }
    });
  }

  sendOtpForVerification(appId) {
    this.lapp.otpForVer(appId).subscribe(
      (data) => {
        if (data['success']) {
          this.phoneNo = data['lapp'][0]['phoneNo'];
          this.otpSent = true;
        } else {
          this.errMsg = data['message'];
          this.toastr.error(data['message']);
        }
      },
      (err) => {
        console.log(err);
        this.toastr.error('OTP verification failed.');
      }
    );
  }

  ngOnInit() {}

  onSubmit() {
    this.signInClicked = true;
    let obj = {
      phoneNo: this.phoneNo,
      code: this.otp,
      appId: this.appId,
    };
    this.lapp.verifyOTP(obj).subscribe(
      (data) => {
        if (data['success']) {
          this.appDetails = data['data'][0];
          this.otpVerified = true;
          this.dApp = data['dApp'];
        } else {
          this.toastr.error('Something went wrong. Please try again.');
        }
        this.signInClicked = false;
      },
      (err) => {
        console.log(err);
        this.toastr.error('Something went wrong. Please try again later.');
      }
    );
  }

  convertNoToWords(val) {
    var a = [
      '',
      'एक ',
      'दोन ',
      'तीन ',
      'चार ',
      'पाच ',
      'सहा ',
      'सात ',
      'आठ ',
      'नऊ ',
      'दहा ',
      'अकरा ',
      'बारा ',
      'तेरा ',
      'चौदा ',
      'पंधरा ',
      'सोळा ',
      'सतरा ',
      'अठरा ',
      'एकोणविस ',
    ];
    var b = [
      '',
      '',
      'वीस',
      'तीस',
      'चाळीस',
      'पन्नास',
      'साठ',
      'सत्तर',
      'अंशी',
      'नव्वद',
    ];

    let nn = val.toString().split('.');
    let n = nn[0];
    if ((n = n.toString()).length > 9) return 'overflow';
    n = ('000000000' + n)
      .substr(-9)
      .match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return;
    var str = '';
    str +=
      n[1] != 0
        ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'करोड '
        : '';
    str +=
      n[2] != 0
        ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'लाख '
        : '';
    str +=
      n[3] != 0
        ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'हजार '
        : '';
    str +=
      n[4] != 0
        ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'शंभर '
        : '';
    str +=
      n[5] != 0
        ? (str != '' ? 'आणि ' : '') +
          (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) +
          'फक्त '
        : '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  numberWithCommas(x) {
    let s = x.toString().trim().split('.');
    x = s[0];
    var lastThree = x.substring(x.length - 3);
    var otherNumbers = x.substring(0, x.length - 3);
    if (otherNumbers != '') {
      lastThree = ',' + lastThree;
    }
    if (s[1]) {
      if (s[1].length > 2) {
        return (
          otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree + '.00'
        );
      } else {
        return (
          otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') +
          lastThree +
          '.' +
          s[1]
        );
      }
    } else {
      return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;
    }
  }

  newDate() {
    if (this.appDetails['loanAgreementAcceptanceTimestamp']) {
      return this.appDetails['loanAgreementAcceptanceTimestamp'];
    } else {
      return new Date();
    }
  }

  agreed() {
    this.btnClicked = true;
    let obj = {
      appId: this.appId,
    };
    this.lapp.userAcceptLoanAgreement(obj).subscribe(
      (data) => {
        if (data['success']) {
          this.accepted = true;
          this.btnClicked = false;
          this.btnShow = false;
          setTimeout(() => {
            this.accepted = false;
          }, 4000);
        }
      },
      (err) => {
        console.log(err);
        this.toastr.error('Something went wrong. Please try again later.');
      }
    );
  }
}
